import { v1 } from './v1';

export const logsGateway = {
  v1,
};
